/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getList({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/user/operations/student-contact?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_LIST", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getUserContactDetail({ commit }, id) {
    const query = {
      "filter[role_id]": 3,
      include: [
        "student",
        "student.level",
        "student.entrancelevel",
        "student.sm",
        "student.ec",
      ],
      append: [
        "total_booking",
        "total_attended",
        "last_attendance",
        "avg_classes_in_week",
      ],
      "fields[student.sm]": "service_officer_id,fullname,avatar",
      "fields[student.ec]": "educational_consultant_id,fullname,avatar",
      "fields[student.level]": "id,title",
      "fields[student.entrancelevel]": "id,title",
    };

    return new Promise((resolve, reject) => {
      axios
        .get(
          `/user/operations/student-contact/user/${id}?${new URLSearchParams(
            query,
          )}`,
        )
        .then((response) => {
          commit("SET_USER_CONTACT_INFOMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  transferToStudent({ commit }, { contact_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/user/operations/student-contact/${contact_id}?`, payload)
        .then((response) => {
          commit("REMOVE_RECORD", contact_id);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};
